"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _core = require("@material-ui/core");

var _LanguageSwitcher = _interopRequireDefault(require("../LanguageSwitcher"));

var _AvatarDropdown = _interopRequireDefault(require("../AvatarDropdown"));

var _NavList = _interopRequireDefault(require("../NavList"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Header = function Header(_ref) {
  var routes = _ref.routes,
      label = _ref.label,
      languages = _ref.languages,
      userAvatarSrc = _ref.userAvatarSrc;
  var currentPath = (0, _reactRedux.useSelector)(function (state) {
    return state.router.location.pathname;
  });
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_core.Typography, {
    variant: 'h6',
    noWrap: true,
    style: {
      flexGrow: 1
    }
  }, label), languages ? _react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, _react.default.createElement(_LanguageSwitcher.default, {
    color: 'white',
    noLabel: true,
    languages: languages
  })) : null, _react.default.createElement(_AvatarDropdown.default, {
    src: userAvatarSrc
  }, _react.default.createElement(_NavList.default, {
    currentPath: currentPath,
    routes: routes,
    isMenu: true,
    isNestedMenu: true
  })));
};

Header.propTypes = {
  languages: _propTypes.default.arrayOf(_propTypes.default.exact({
    code: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired
  })),
  label: _propTypes.default.node,
  userAvatarSrc: _propTypes.default.string,
  routes: _propTypes.default.array
};
var _default = Header;
exports.default = _default;